import Funcion from "../atoms/Funcion";
import caidas from "../../images/funciones/1-ico-caidas.svg";
import ayuda from "../../images/funciones/2-ico-ayuda.svg";
import monitoreo from "../../images/funciones/3-ico-monitoreo.svg";
import habitos from "../../images/funciones/4-ico-habitos.svg";
import cognitivas from "../../images/funciones/5-ico-cognitivas.svg";
import top from "../../images/funciones/top-funciones.png";

import "./Funciones.css";

export const Funciones = () => {
  return (
    <div id="funciones">
      <div className="funciones-container-top">
        <img className="funciones-image-top" src={top} alt="Top Funciones" />
      </div>

      <div className="funciones-container-titles">
        <h1>Elegimos cuidarnos y cuidarlos</h1>
        <sub>Elegimos seguir disfrutando la vida</sub>
      </div>

      <div className="funciones-container">
        <Funcion image={caidas} title="Detección de Caídas" />
        <Funcion image={ayuda} title="Botón de Ayuda" />
        <Funcion
          image={monitoreo}
          title="Monitoreo de Salud"
          sub="(Próximamente)"
        />
        <Funcion
          image={habitos}
          title="Hábitos Saludables"
          sub="(Próximamente)"
        />
        <Funcion
          image={cognitivas}
          title="Funciones Neuro-Cognitivas"
          sub="(Próximamente)"
        />
      </div>
    </div>
  );
};

export default Funciones;
